import { useTranslation } from 'react-i18next';

export function useLanguage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language === 'ko' ? 'ko' : 'en';

  const toggleLanguage = () => {
    i18n.changeLanguage(currentLang === 'ko' ? 'en' : 'ko');
  };

  const setLanguage = (lang: 'ko' | 'en') => {
    i18n.changeLanguage(lang);
  };

  return { currentLang, toggleLanguage, setLanguage };
}